"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Display3 = exports.Display2 = exports.Display1 = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var tokens_1 = require("../../../tokens");
exports.Display1 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.display1));
exports.Display2 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.display2));
exports.Display3 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.display3));
//# sourceMappingURL=index.js.map